<span [popover]="invoiceRecipientDetails" triggers="mouseenter:mouseleave" placement="right">
    <select [(ngModel)]="selectedRecipient"
            (change)="recipientChanged()"
            class="form-select form-select-sm"
            [disabled]="!recipients.length || !editMode">
        <option [ngValue]="undefined"></option>
        @for (recipient of recipients; track recipient) {
            <option [ngValue]="recipient">{{ recipient.name }}</option>
        }
    </select>
</span>

<ng-template #invoiceRecipientDetails>
    @if (!selectedRecipient) {
        <em>No recipient selected</em>
    }
    @if (selectedRecipient) {
        <address>
            {{ selectedRecipient.clientName }}
            <br> {{ selectedRecipient.name }}
            <br> {{ selectedRecipient.title }}
            <br> {{ selectedRecipient.address1 }}
            <br> {{ selectedRecipient.address2 }}
            @if (selectedRecipient.address2) {
                <br>
            } {{ selectedRecipient.city }}
            @if (selectedRecipient.city) {
                <span>,</span>
            } {{ selectedRecipient.state }} {{ selectedRecipient.postalCode }}
        </address>
    }
</ng-template>
